<template>
	<div>
		<div class="flex" style="margin-bottom: 10px;"><el-button type="primary" @click="addFunction(false)">添加方法</el-button></div>
		<el-table
			:data="authList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="id"
			border
			:stripe="true"
			:default-sort="{ prop: 'ctime', order: 'ascending' }"
			@sort-change="sortChange"
		>
			<el-table-column prop="id" label="方法ID" width="80"></el-table-column>
			<el-table-column prop="name" label="方法名"></el-table-column>
			<el-table-column prop="directory" label="控制目录"></el-table-column>
			<el-table-column prop="controller" label="控制器"></el-table-column>
			<el-table-column prop="function" label="方法"></el-table-column>
			<el-table-column prop="menu_name" label="菜单目录"></el-table-column>
			<el-table-column prop="ctime" label="添加时间" sortable></el-table-column>
			<el-table-column label="操作" min-width="100">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="addFunction(scope.row)">修改</el-button>
					<el-button type="danger" size="small">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="thispage"
				:page-sizes="pageSizes"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
		<el-dialog title="添加方法" :visible.sync="addDialogShow" width="70%" v-loading="loading" :close-on-click-modal="false">
			<div style="text-align: left;min-height: 50vh;max-height: 80vh;">
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">方法名</span></el-col>
					<el-col :span="12"><el-input v-model="addFunctionInfo.name" placeholder="请输入方法名称"></el-input></el-col>
				</el-row>
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">菜单目录</span></el-col>
					<el-col :span="12">
						<el-cascader
							v-model="addFunctionInfo.menu_id"
							:options="menuList"
							@change="menuChange"
							:props="{ label: 'name', value: 'id' }"
						></el-cascader>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">方法目录</span></el-col>
					<el-col :span="12"><el-input v-model="addFunctionInfo.directory" placeholder="请输入目录名称"></el-input></el-col>
				</el-row>
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">控制器</span></el-col>
					<el-col :span="12"><el-input v-model="addFunctionInfo.controller" placeholder="请输入控制器名称"></el-input></el-col>
				</el-row>
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">方法</span></el-col>
					<el-col :span="12"><el-input v-model="addFunctionInfo.function" placeholder="请输入方法名称"></el-input></el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialogShow = false">取 消</el-button>
				<el-button type="primary" @click="addSubmit()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
	name: '',
	data() {
		return {
			authList: [],
			menuList: [],
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			currentScope: '',
			loading: false,
			addDialogShow: false,
			addFunctionInfo: {},
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 20, 30] ,//每页显示个数选择器
			sort_param:'',//排序字段
			sort_type:''//排序方式ascending = asc;descending = desc,'' = asc;
		};
	},
	mounted() {
		this.getAuthList();
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		getAuthList() {
			this.$axios({
				url: this.HOST + '/admin.setting/authList',
				method: 'post',
				data: {
					thispage: this.thispage,
					pagesize: this.pagesize,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					sort_param:this.sort_param,
					sort_type:this.sort_type
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.total = res.data.total;
						this.authList = res.data.authList;
						if (this.thispage == 1) {
							this.menuList = res.data.menuList;
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending'?'desc':'asc';
			this.getAuthList()
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getAuthList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getAuthList();
		},
		menuChange(e) {
			let i = e.length;
			this.addFunctionInfo.menu_id = e[i - 1];
			console.log(e[i - 1]);
		},
		getCheckedNodes(refName) {
			this.$confirm('确认修改当前管理员权限信息吗？')
				.then(() => {
					this.loading = true;
					let arr = this.$refs[refName].getCheckedNodes();
					let newArr = [];
					for (let i in arr) {
						if (!arr[i].children) {
							newArr.push(arr[i].id);
						}
					}
					this.currentScope[refName + '_list'] = newArr;
					this.$axios({
						url: this.HOST + '/admin.setting/changeManageGroup',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							id: this.currentScope.id,
							auth_list: this.currentScope.auth_list,
							menu_list: this.currentScope.menu_list
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$message.success(res.data.msg);
								this[refName + 'TreeShow'] = false;
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		},
		addFunction(scope = false) {
			if (!scope) {
				this.addFunctionInfo = {
					name: '',
					menu_id: '',
					directory:'',
					controller:'',
					function:''
				};
			} else {
				this.addFunctionInfo = JSON.parse(JSON.stringify(scope));
			}
			console.log(this.addFunctionInfo);
			this.addDialogShow = true;
		},
		addSubmit() {
			this.$confirm('确认信息无误并提交？')
				.then(() => {
					this.loading = true;
					console.log(this.addFunctionInfo);
					this.$axios({
						url: this.HOST + '/admin.setting/addFunction',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							functionInfo: this.addFunctionInfo
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$message.success(res.data.msg);
								this.addDialogShow = false;
								this.getAuthList();
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		}
	}
};
</script>
<style>
.el-tree-node.is-expanded > .el-tree-node__children {
	display: flex;
	flex-flow: row wrap;
}
.el-tree::-webkit-scrollbar {
	display: none; /* Chrome Safari */
}
</style>
